module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Mosnang-fb6d66d013281ebd5e81ab9b7dea2b49.png";